import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import OrderNow from "./pages/OrderNow";
import CombinedComponent from "./components/combinecontact";
import ContactPage from "./pages/ContactPage";
import MyServiceComponent from "./pages/servicespage";
import Disseration from "./pages/disserationpage";
import CourseworkPage from "./pages/courseworkpage";
import DataAnalysispage from "./pages/dataanalysispage";
import Editingpage from "./pages/editingpage";
import CoursesPage from "./pages/coursespage";
import LiteraturePage from "./pages/literaturepage";
import ResearchPage from "./pages/researchpage";
import Blog from "./components/Blog";
import BlogPostContent from "./pages/BlogPostContent";
import ManuscriptPage from "./pages/manuscriptpage";
import Blogpage from "./pages/blogpage";
import "../src/App.css";
import LandingPage from "./pages/landingpage";
import LandingHeader from "./components/servicepage/landingheader";
import Landingpg2 from "./pages/Landingpg2.0";
import DisserationServicepg from "./pages/desserationservicepg";


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return !loading ? (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/OrderNow" element={<OrderNow />} />
        <Route path="/" element={<CombinedComponent />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/academic-writing-services" element={<Landingpg2 />} />
        <Route path="/master-dissertation-services" element={<DisserationServicepg />} />
        <Route
          path="/dissertation-writing-services"
          element={<Disseration />}
        />

        <Route path="/coursework-writing" element={<CourseworkPage />} />
        <Route path="/data-analysis-services" element={<DataAnalysispage />} />
        <Route path="/project-report-writing" element={<Editingpage />} />
        <Route path="/publication-services" element={<CoursesPage />} />
        <Route path="/literature-review-writing" element={<LiteraturePage />} />
        <Route path="/manuscript-preparation" element={<ManuscriptPage />} />
        <Route
          path="/research-methodology-services"
          element={<ResearchPage />}
        />
         <Route
          path="/assignment-writing-services"
          element={<LandingPage />}
        />

        <Route
          path="service-dessertation"
          element={<DisserationServicepg />}
        />


     
        
      </Routes>
    </Router>
  ) : (
    <div
      style={{
        width: "1px",
        height: "200px",
        border: "1px solid black",
        position: "absolute",
        top: "30%",
        left: "50%",
        zIndex: "1000",
      }}
    >
      <div
        className="preloader"
        style={{
          width: "1px",
          height: "50px",
          top: "20%",
          border: "1px solid white",
        }}
      ></div>
    </div>
  );
};

export default App;
